export default {
  isUserAuth(state) {
    return state.isUserAuth;
  }
}